import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Bell, CheckCheck } from "lucide-react";
import { formatDistanceToNow } from "date-fns";
import { fr } from "date-fns/locale";

export default function Notifications() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/notifications").then(r => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };
  const markOne = async (id) => { await api.post(`/notifications/${id}/read`); load(); };

  const linkFor = (n) => {
    if (n.data?.product_id) return `/produit/${n.data.product_id}`;
    if (n.data?.shop_id) return `/boutique/${n.data.shop_id}`;
    if (n.data?.order_id) return `/commandes`;
    return "#";
  };

  return (
    <div className="max-w-2xl mx-auto px-3 sm:px-6 py-4">
      <div className="flex items-center justify-between">
        <h1 className="font-[Manrope] font-bold text-xl">Notifications</h1>
        {items.some(i => !i.read) && <Button size="sm" variant="outline" onClick={markAll} data-testid="mark-all-read"><CheckCheck className="h-4 w-4 mr-1" />Tout marquer lu</Button>}
      </div>
      <div className="mt-4 space-y-2">
        {items.length === 0 && (
          <div className="py-16 text-center text-sm text-[#73706B]">
            <Bell className="h-10 w-10 mx-auto mb-3 opacity-40" />
            Aucune notification pour l'instant
          </div>
        )}
        {items.map(n => (
          <Link to={linkFor(n)} onClick={() => !n.read && markOne(n.id)} key={n.id} data-testid={`notif-${n.id}`} className={`block p-3 rounded-xl border transition ${n.read ? "border-[#E8E6E1] bg-white" : "border-[#E65100]/40 bg-[#FFF8F3]"}`}>
            <div className="font-bold text-sm">{n.title}</div>
            <div className="text-xs text-[#1A1918] mt-0.5">{n.body}</div>
            <div className="text-[10px] text-[#73706B] mt-1">{tryDate(n.created_at)}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}

function tryDate(iso) {
  try { return formatDistanceToNow(new Date(iso), { addSuffix: true, locale: fr }); } catch { return ""; }
}
